// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type SendForbruksstoppNotificationMutationVariables = Types.Exact<{
  measuringpointId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SendForbruksstoppNotificationMutation = { sendForbruksstoppNotification: boolean };

export type SendSpotpriceNotificationMutationVariables = Types.Exact<{
  operator?: Types.InputMaybe<Types.SpotpriceLevelOperator>;
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  area?: Types.InputMaybe<Types.NordpoolArea>;
}>;


export type SendSpotpriceNotificationMutation = { sendSpotpriceNotification: boolean };

export type SendWeekreportNotificationMutationVariables = Types.Exact<{
  measuringpointId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  week: Types.Scalars['Int']['input'];
}>;


export type SendWeekreportNotificationMutation = { sendWeekreportNotification: boolean };


export const SendForbruksstoppNotificationDocument = gql`
    mutation sendForbruksstoppNotification($measuringpointId: String, $userId: String) {
  sendForbruksstoppNotification(
    measuringpointId: $measuringpointId
    userId: $userId
  )
}
    `;
export type SendForbruksstoppNotificationMutationFn = ApolloReactCommon.MutationFunction<SendForbruksstoppNotificationMutation, SendForbruksstoppNotificationMutationVariables>;

/**
 * __useSendForbruksstoppNotificationMutation__
 *
 * To run a mutation, you first call `useSendForbruksstoppNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForbruksstoppNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForbruksstoppNotificationMutation, { data, loading, error }] = useSendForbruksstoppNotificationMutation({
 *   variables: {
 *      measuringpointId: // value for 'measuringpointId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendForbruksstoppNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendForbruksstoppNotificationMutation, SendForbruksstoppNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendForbruksstoppNotificationMutation, SendForbruksstoppNotificationMutationVariables>(SendForbruksstoppNotificationDocument, options);
      }
export type SendForbruksstoppNotificationMutationHookResult = ReturnType<typeof useSendForbruksstoppNotificationMutation>;
export type SendForbruksstoppNotificationMutationResult = ApolloReactCommon.MutationResult<SendForbruksstoppNotificationMutation>;
export type SendForbruksstoppNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendForbruksstoppNotificationMutation, SendForbruksstoppNotificationMutationVariables>;
export const SendSpotpriceNotificationDocument = gql`
    mutation sendSpotpriceNotification($operator: SpotpriceLevelOperator, $userId: String, $area: NordpoolArea) {
  sendSpotpriceNotification(operator: $operator, userId: $userId, area: $area)
}
    `;
export type SendSpotpriceNotificationMutationFn = ApolloReactCommon.MutationFunction<SendSpotpriceNotificationMutation, SendSpotpriceNotificationMutationVariables>;

/**
 * __useSendSpotpriceNotificationMutation__
 *
 * To run a mutation, you first call `useSendSpotpriceNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSpotpriceNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSpotpriceNotificationMutation, { data, loading, error }] = useSendSpotpriceNotificationMutation({
 *   variables: {
 *      operator: // value for 'operator'
 *      userId: // value for 'userId'
 *      area: // value for 'area'
 *   },
 * });
 */
export function useSendSpotpriceNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSpotpriceNotificationMutation, SendSpotpriceNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSpotpriceNotificationMutation, SendSpotpriceNotificationMutationVariables>(SendSpotpriceNotificationDocument, options);
      }
export type SendSpotpriceNotificationMutationHookResult = ReturnType<typeof useSendSpotpriceNotificationMutation>;
export type SendSpotpriceNotificationMutationResult = ApolloReactCommon.MutationResult<SendSpotpriceNotificationMutation>;
export type SendSpotpriceNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSpotpriceNotificationMutation, SendSpotpriceNotificationMutationVariables>;
export const SendWeekreportNotificationDocument = gql`
    mutation sendWeekreportNotification($measuringpointId: String, $userId: String, $week: Int!) {
  sendWeekreportNotification(
    measuringpointId: $measuringpointId
    userId: $userId
    week: $week
  )
}
    `;
export type SendWeekreportNotificationMutationFn = ApolloReactCommon.MutationFunction<SendWeekreportNotificationMutation, SendWeekreportNotificationMutationVariables>;

/**
 * __useSendWeekreportNotificationMutation__
 *
 * To run a mutation, you first call `useSendWeekreportNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWeekreportNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWeekreportNotificationMutation, { data, loading, error }] = useSendWeekreportNotificationMutation({
 *   variables: {
 *      measuringpointId: // value for 'measuringpointId'
 *      userId: // value for 'userId'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useSendWeekreportNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendWeekreportNotificationMutation, SendWeekreportNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendWeekreportNotificationMutation, SendWeekreportNotificationMutationVariables>(SendWeekreportNotificationDocument, options);
      }
export type SendWeekreportNotificationMutationHookResult = ReturnType<typeof useSendWeekreportNotificationMutation>;
export type SendWeekreportNotificationMutationResult = ApolloReactCommon.MutationResult<SendWeekreportNotificationMutation>;
export type SendWeekreportNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendWeekreportNotificationMutation, SendWeekreportNotificationMutationVariables>;